import React from 'react';
import './ScoreDisplay.css';

interface KPIDisplayProps {
  sessionDuration: number; // in seconds
}

const KPIDisplay: React.FC<KPIDisplayProps> = ({ sessionDuration }) => {
  const formatTime = (seconds: number): string => {
    if (seconds < 60) {
      return `${seconds.toFixed(1)}s`;
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}m ${remainingSeconds}s`;
  };

  return (
    <div className="kpi-display">
      <div className="kpi-item">
        <div className="kpi-label">Session Time</div>
        <div className="kpi-value">{formatTime(sessionDuration)}</div>
      </div>
    </div>
  );
};

export default KPIDisplay;